import React from 'react';
import { useHistory } from 'react-router-dom';
import { css } from '@emotion/core';
import IconLabelButton from 'components/molecules/IconLabelButton';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import Dropdown from 'components/molecules/Dropdown';
import productColor from 'components/styles';
import Icon from 'components/atoms/Icon';

const ButtonNavigation: React.FC<{
  downloadOrganization: () => void;
  downloadManagerCsv: () => void;
  downloadSpecialSalaryCsv: () => void;
}> = ({ downloadOrganization, downloadManagerCsv, downloadSpecialSalaryCsv }) => {
  const history = useHistory();
  const isAuthorizedFromPeople = process.env.REACT_APP_IS_AUTHORIZED_FROM_PEOPLE === "true"|| false;

  return (
    <FlexBox customStyle={css({ paddingRight: '12px' })}>
      <FlexBoxItem marginLeft="auto">
        {isAuthorizedFromPeople?'':
        <IconLabelButton onClick={() => history.push('/organizations/add')} iconType="addCircle" text="追加" />
        }
        {/* <Link to="/organizations/csv" style={{ textDecoration: 'none'}}>
          <Icon type="addCircle" color={productColor.primary} />
          <BodyText
            color={productColor.primary}
            customStyle={css({
              marginLeft: '4px',
              textDecoration: 'none'
            })}
          >
            追加
          </BodyText>
        </Link> */}
      </FlexBoxItem>
      <FlexBoxItem marginLeft="20px">
        <IconLabelButton onClick={() => history.push('/organizations/csv')} iconType="addCircle" text="インポート" />
        {/* <Link to="/organizations/add" style={{ textDecoration: 'none'}}>
          <Icon type="addCircle" color={productColor.primary} />
          <BodyText
            color={productColor.primary}
            customStyle={css({
              marginLeft: '4px',
            })}
          >
            インポート
          </BodyText>
        </Link> */}
      </FlexBoxItem>
      <FlexBoxItem marginLeft="20px">
        {/* <IconLabelButton onClick={() => downloadOrganization()} iconType="download" text="ダウンロード" /> */}
        <Dropdown hasIconDropDown={false}
          items={[
            {
              value: '0',
              label: '組織情報',
              onClick: downloadOrganization,
            },
            {
              value: '2',
              label: 'マネージャー権限',
              onClick: downloadManagerCsv,
            },
          ]}
        >
          <IconLabelButton onClick={() => {}} iconType="download" text="CSVダウンロード" />
          {/* <Icon type="download" color={productColor.primary} />
          <BodyText
            color={productColor.primary}
            customStyle={css({
              marginLeft: '4px',
            })}
          >
            ダウンロード
          </BodyText> */}
        </Dropdown>
      </FlexBoxItem>
    </FlexBox>
  );
}

export default ButtonNavigation;
